import { Link } from "react-router-dom";
import type { ReviewItem } from "@/types/content";

export default function ReviewCard({ item }: { item: ReviewItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col gap-4 rounded-lg border border-background-300 bg-background-50 p-4 transition-colors hover:border-primary-300 sm:flex-row"
    >
      <div className="h-40 w-full shrink-0 overflow-hidden rounded-md sm:h-28 sm:w-44">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 我的朋友他的妻子精彩剧评`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <h3 className="text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1.5 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {item.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {item.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-primary-500"></i>
            热度 {item.popularity}
          </span>
          {item.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-accent-100 px-2 py-0.5 text-accent-900"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}